import type { RouteObject } from 'react-router-dom';
import { MarketingLayout } from './layouts/MarketingLayout';
import { HomePage } from './pages/HomePage';
import { FeaturesOverviewPage } from './pages/FeaturesOverviewPage';
import { FeaturePage } from './pages/FeaturePage';
import { PricingPage } from './pages/PricingPage';
import { ContactPage } from './pages/ContactPage';
import { PolicyPage } from './pages/PolicyPage';
import { GuidesIndexPage } from './pages/GuidesIndexPage';
import { GuidePage } from './pages/GuidePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { GUIDES } from './content/guides';

// The guides section only exists once there is at least one guide to show.
const guideRoutes: RouteObject[] =
  GUIDES.length > 0
    ? [
        { path: '/guides', element: <GuidesIndexPage /> },
        { path: '/guides/:slug', element: <GuidePage /> },
      ]
    : [];

export const routes: RouteObject[] = [
  {
    element: <MarketingLayout />,
    children: [
      { path: '/', element: <HomePage /> },
      { path: '/features', element: <FeaturesOverviewPage /> },
      { path: '/features/:slug', element: <FeaturePage /> },
      { path: '/pricing', element: <PricingPage /> },
      { path: '/contact', element: <ContactPage /> },
      ...guideRoutes,
      { path: '/privacy-policy', element: <PolicyPage policy="privacy" /> },
      { path: '/privacy-policy/listing-extension', element: <PolicyPage policy="listing-extension-privacy" /> },
      { path: '/terms-of-service', element: <PolicyPage policy="terms" /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
];
